import { DataBean } from "../DataBean";

export class FixedAssetItemDevaluation extends DataBean {


    public async getFixedAssetItemDevaluationCatalog(idItem:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFixedAssetItemDevaluationCatalog_Number", [idItem]);
    }
    
}